'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import enviro from 'enviro';
import ViralLink from 'viral-links-lib/viral-link/ViralLink';
import { jsx as _jsx } from "react/jsx-runtime";
function FreemiumLink({
  portalId,
  embedded
}) {
  const verticalPadding = embedded ? 'p-y-2' : 'p-y-3';
  const linkType = embedded ? `meetings-embedded` : `meetings`;
  const environment = enviro.isQa() ? 'qa' : 'prod';
  return /*#__PURE__*/_jsx("div", {
    className: `text-center date-picker-freemium-cta ${verticalPadding}`,
    children: /*#__PURE__*/_jsx(ViralLink, {
      portalId: portalId,
      viralLinkType: linkType,
      isExternalLink: embedded,
      use: "primary",
      justifyContent: "center",
      environment: environment,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "prebook.freemium.viralLink"
      })
    })
  });
}
class FreemiumBookingUpgradeLink extends Component {
  render() {
    const {
      embedded,
      portalId
    } = this.props;
    return /*#__PURE__*/_jsx(FreemiumLink, {
      embedded: embedded,
      portalId: portalId
    });
  }
}
export default connect(state => ({
  portalId: state.portalId
}))(FreemiumBookingUpgradeLink);